import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';

const ObjectValue = ({ value, empty }) => {
	return <div className="string-value">{value ? JSON.stringify(value) : empty}</div>;
};

ObjectValue.propTypes = {
	value: PropTypes.any,
	empty: PropTypes.string,
};

ObjectValue.defaultProps = {
	empty: '-',
};

export default observer(ObjectValue);
